// src/utils/generateId.js
// Generates unique IDs for outreach messages — used for attribution tracking

/**
 * Generates a unique message ID (UUID v4).
 * Attaches to every outreachLog entry so we can attribute payments
 * back to the specific message that triggered them.
 */
export function generateMessageId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older environments
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
